import { PropsWithChildren } from 'react';
import { EVENT_ENTRY_SOURCE_TEST_ID } from '../StartNodeEditor.constants';
import { useGetEntrySourceMetadata } from '../StartNodeEditor.hooks';
import { EventResourceForm } from './EventResourceForm';
import { EntrySourceContainer } from '../StartNodeEditor.styled';
import { EventTypeSelect } from './EventTypeSelect';
import { EntrySourceComponentProps } from '../StartNodeEditor.types';

export const EventEntrySource = ({
  displayValue,
  hasCloningError,
  children,
}: PropsWithChildren<EntrySourceComponentProps>) => {
  const { resourceType = '' } = useGetEntrySourceMetadata();

  return (
    <EntrySourceContainer data-test={EVENT_ENTRY_SOURCE_TEST_ID}>
      <EventTypeSelect />
      {resourceType && (
        <EventResourceForm displayValue={displayValue} hasCloningError={hasCloningError} />
      )}
      {children}
    </EntrySourceContainer>
  );
};
